import * as Immutable from "immutable";
import { Panel } from "./panel";

export class TextPanel extends Panel {

  protected readonly TEXT = "text";

  get text(): string { return this.getInternalValue<string>(this.TEXT); }
  settext(text: string): this { return this.setInternalValue(this.TEXT, text); }

}